import { LEReportData, ReportScore, ReportTreeNode } from '../types';
import { flattenTree, updateScoreData } from './CommonReportHelper';

export const flattenLessonTree = (lessonTree: ReportTreeNode) => {
  return flattenTree(lessonTree);
};

export const fillLessonScoreData = (
  lessonScoreData: LEReportData,
  lessonReportData: LEReportData,
  lessonTree: ReportTreeNode,
) => {
  // Step 1: Update only the exact matching leaf nodes (lessons from lessonReportData)
  const updateLeafNodes = (node: ReportTreeNode, userId: string) => {
    const nodeIdStr = `${node.id}`;
    const lessonScoreObj = lessonReportData?.[userId]?.[nodeIdStr] as ReportScore;

    // If this node has data in lessonReportData, update it
    if (lessonScoreObj) {
      updateScoreData(lessonScoreData, userId, nodeIdStr, lessonScoreObj);
    }

    // Recursively process all subNodes
    node.subNodes.forEach((subNode) => {
      updateLeafNodes(subNode, userId);
    });
  };

  // Step 2: Aggregate scores from children to parents (bottom-up)
  const aggregateToParents = (node: ReportTreeNode, userId: string) => {
    // First, recursively process all children
    node.subNodes.forEach((subNode) => {
      aggregateToParents(subNode, userId);
    });

    // Then, aggregate children's scores into this parent node
    if (node.subNodes.length > 0) {
      const nodeIdStr = `${node.id}`;
      node.subNodes.forEach((subNode) => {
        const childIdStr = `${subNode.id}`;
        const childScore = lessonScoreData[userId]?.[childIdStr];
        if (childScore) {
          updateScoreData(lessonScoreData, userId, nodeIdStr, childScore);
        }
      });
    }
  };

  // Process each user
  const userIds = Object.keys(lessonReportData);
  userIds.forEach((userId) => {
    // First pass: Update leaf nodes only
    updateLeafNodes(lessonTree, userId);

    // Second pass: Aggregate from children to parents
    aggregateToParents(lessonTree, userId);
  });

  return lessonScoreData;
};
